import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const MiscCalculationGlyph = /*#__PURE__*/createElement("g", {
  id: "misc_calculation"
}, /*#__PURE__*/createElement("path", {
  d: "M40.5 15.62h3v52.77h-3z"
}), /*#__PURE__*/createElement("path", {
  d: "M15.09 40.5H68.9v3H15.09zm13.28-4.52c-.83 0-1.5-.67-1.5-1.5v-9.87c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v9.87c0 .83-.67 1.5-1.5 1.5z"
}), /*#__PURE__*/createElement("path", {
  d: "M33.48 31H23.41c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5h10.06c.83 0 1.5.67 1.5 1.5S34.3 31 33.48 31zm26.42.05H49.84c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5H59.9c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5zm0 28.7H49.84c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5H59.9c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5zm0-5.16H49.84c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5H59.9c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5zM31.91 60.74c-.38 0-.77-.15-1.06-.44l-6.98-6.98c-.59-.59-.59-1.54 0-2.12s1.54-.59 2.12 0l6.98 6.98c.59.59.59 1.54 0 2.12-.29.29-.67.44-1.06.44z"
}), /*#__PURE__*/createElement("path", {
  d: "M24.89 60.72c-.38 0-.77-.15-1.06-.44a1.49 1.49 0 010-2.12l7.12-7.12c.59-.59 1.54-.59 2.12 0s.59 1.54 0 2.12l-7.12 7.12c-.3.3-.68.44-1.06.44z"
}), /*#__PURE__*/createElement("path", {
  d: "M68 69.5H16c-.83 0-1.5-.67-1.5-1.5V16c0-.83.67-1.5 1.5-1.5h52c.83 0 1.5.67 1.5 1.5v52c0 .83-.67 1.5-1.5 1.5zm-50.5-3h49v-49h-49v49z"
}));
const MiscCalculation = createSvg({
  name: 'misc_calculation',
  path: MiscCalculationGlyph
});

export default MiscCalculation;
export { MiscCalculationGlyph };
